module.exports = __webpack_public_path__ + "static/media/loading_big.b3419887.gif";